import { LoadingIndicator } from "@/Icons/loadingIndicator";

import { twMerge } from "tailwind-merge";

type Props = {
  isLoading: boolean;
  loaderClassName?: string;
  children: React.ReactNode;
};

export const ViewWithLoader: React.FC<Props> = ({
  isLoading,
  loaderClassName = "h-[110px]",
  children,
}) => {
  return isLoading ? (
    <div
      className={twMerge(
        "flex h-full min-h-full w-full items-center justify-center",
        loaderClassName,
      )}
    >
      <LoadingIndicator />
    </div>
  ) : (
    children
  );
};
